// Output Variables
const CARDS = [
  {
    title: `Annual Passenger Kilometers Traveled per Capita`,
    description: `Passenger kilometers traveled as a final output is useful for cities to understand how population, GDP, and the investment of non-motorized transit (pedestrian walkways, bikes, cycle rickshaws) can impact motorized passenger travel demand`,
    key: "passengerDistanceTraveled" // Used to index into "chart metadata"
  },
  {
    title: `Annual Total Vehicle Kilometers`,
    description: `Vehicle Kilometers Traveled (VKT) can be reduced through investment in shared mobility.`,
    key: "vehicleDistanceTraveled"
  },
  {
    title: `Carbon Dioxide Emissions`,
    description: `Carbon Dioxide (CO2) is produced by vehicles with ICE (Internal Combustion Engine), as well as by the underlying power grid for charging electric vehicles.`,
    key: "co2Emissions"
  },
  {
    title: `Vehicular Particulate Matter (PM-2.5) Emissions`,
    description: `PM 2.5 emissions are produced by vehicles with ICE (Internal Combustion Engine).`,
    key: "pm25Emissions"
  },
  {
    title: `Modal Split`,
    description: ` Modal split displays how investments in shared mobility and public transit shifts the percentage of passenger kilometers traveled to different modes of travel. `,
    key: "modalSplit"
  }
];

export default CARDS;



// WEBPACK FOOTER //
// ./src/data/cards.js